import { useEffect, useState, ReactElement } from 'react'
import {useParams, useSearchParams} from 'react-router-dom'
import { useLocalization } from './i18n/i18n'
import TryOn from './components/TryOn'
import useWindowDimensions from './hooks/useWindowDimensions'
import LocalData from './services/LocalData'
import Placeholder from './components/Placeholder'
import './App.css'

interface WebModuleState {
  loading: boolean
  data?: any
  errorCode?: any
  errorMessage: any
}

const INITIAL_STATE: WebModuleState = {
  loading: false,
  data: undefined,
  errorCode: undefined,
  errorMessage: ''
}

const IMAGE_ASPECT_RATIO = 800 / 640

function TopologyWebModuleModelV0 (): ReactElement {
  let { patientId }: any = useParams()
  let [params]: any = useSearchParams()
  let sku = params.get('sku')
  let slideFull = params.get('slideFull') || ''

  const { width, height } = useWindowDimensions()
  const [state, setState] = useState(INITIAL_STATE)
  const t = useLocalization()

  const { loading, data, errorCode, errorMessage } = state

  useEffect(() => {
    const fetchData = async (patientId: string, sku: string): Promise<void> => {
      const oldState = { loading, patientId, sku }
      const response = await LocalData.tryOnModelV0(patientId, sku)
      let errorCode
      let errorMessage = ''

      if (response?.errorCode !== undefined || response?.errorMessage !== undefined) {
        errorCode = response?.errorCode
        errorMessage = (typeof response?.errorMessage === 'string') ? response.errorMessage : ''
      }
      setState({
        ...oldState,
        loading: false,
        data: response.result,
        errorCode,
        errorMessage
      })
    }

    const f = async (): Promise<void> => {
      if (patientId !== undefined && sku !== undefined) {
        await fetchData(patientId, sku)
      }
    }
    f().then(
      () => {
      },
      () => {
      }
    )
    return undefined
  }, [patientId, sku, loading])

  if (errorCode !== undefined || errorMessage !== '') {
    return (
      <Placeholder
        width={width}
        height={height}
      >
        Error{errorCode ? ` ${errorCode}` : ``}: {t(errorMessage)}
      </Placeholder>
    )
  }

  if (patientId === undefined) {
    return (
      <Placeholder height={height} width={width}>
        {t('errNoPatientParam')}
      </Placeholder>
    )
  }

  if (sku === undefined) {
    return (
      <Placeholder height={height} width={width}>
        {t('errNoSkuParam')}
      </Placeholder>
    )
  }

  if (data === undefined) {
    return (
      <Placeholder
        height={height}
        width={width}
        loading
      >
        {t('buildingTryon')}
      </Placeholder>
    )
  }

  return (
    <>
      {Array.isArray(data) && (
        <TryOn
          data={data}
          height={height}
          width={width}
          aspectRatio={IMAGE_ASPECT_RATIO}
          slideFull={slideFull}
        />
      )}
    </>
  )
}

export default TopologyWebModuleModelV0
